var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.masterAdmin == true ? _c("masteradmin-sidebar-menu") : _vm._e(),
          _vm._v(" "),
          _vm.csr == true ? _c("CSRSidebarMenu") : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-wrapper" },
            [
              _c(
                "div",
                { staticClass: "container-wrapper center" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "heading-seperator" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "margin-bottom-10" }),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c("div", { staticClass: "row tasks_heading_row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "bold col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3"
                          },
                          [
                            _vm._v(
                              "\n                       First Name\n                     "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                          },
                          [
                            _vm._v(
                              "\n                       Last Name\n                     "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "bold col-xl-7 col-lg-7 col-md-7 col-sm-6 col-6 override-padding"
                          },
                          [
                            _vm._v(
                              "\n                       Email\n                     "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          staticClass: "loading_show"
                        },
                        [
                          _c("div", {
                            staticClass: "spinner-border text-danger"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.email_lists.length > 0
                        ? _c(
                            "b-card-text",
                            _vm._l(_vm.email_lists, function(emaillist, index) {
                              return _c(
                                "div",
                                { staticClass: "tasklist-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row tasklist-item",
                                      staticStyle: { margin: "0" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3"
                                        },
                                        [_vm._v(_vm._s(emaillist.admin_fname))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                                        },
                                        [_vm._v(_vm._s(emaillist.admin_lname))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 override-padding"
                                        },
                                        [_vm._v(_vm._s(emaillist.admin_email))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xl-2 col-lg-2 col-md-2 col-sm-1 col-1 override-padding"
                                        },
                                        [
                                          emaillist.is_enabled == 1
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "cursor-pointer",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.switchUserLogin(
                                                        emaillist.uid
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-user spacer-icon"
                                                  }),
                                                  _vm._v(
                                                    "Login\n                              "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xl-2 col-lg-2 col-md-2 col-sm-1 col-1 override-padding"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "dropdown",
                                              attrs: {
                                                id: "dropdown-container" + index
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.toggleDropdown(
                                                    "actionDropdown" +
                                                      index +
                                                      ""
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "dropbtn icons btn-right showLeft",
                                                  attrs: {
                                                    id:
                                                      "dotted-menu-private" +
                                                      index
                                                  }
                                                },
                                                [
                                                  _c("li"),
                                                  _vm._v(" "),
                                                  _c("li"),
                                                  _vm._v(" "),
                                                  _c("li")
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-content",
                                                  attrs: {
                                                    id: "actionDropdown" + index
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "action-dd-menu",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.resetPasswordEmail(
                                                            emaillist.admin_email
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "cursor-pointer fa fa-key spacer-icon"
                                                      }),
                                                      _vm._v("Reset Password")
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "action-dd-menu",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.sendEmailForm(
                                                            emaillist.admin_email
                                                          ),
                                                            _vm.verrors.clear()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "cursor-pointer fa fa-envelope-square spacer-icon"
                                                      }),
                                                      _vm._v("Send Mail")
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [_c("hr")])
                                ]
                              )
                            }),
                            0
                          )
                        : _vm.loading == false
                        ? _c("b-card-text", [
                            _vm._v(
                              "\n                          No records found\n                     "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.successMessage
                ? _c(
                    "ValidationModal",
                    {
                      attrs: { isModalVisible: _vm.isInfoModalVisible },
                      on: {
                        close: function($event) {
                          _vm.isInfoModalVisible = false
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "pull-right text-danger" }, [
                        _vm._v("\n      Loading...\n    ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "sub-heading",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [_vm._v(_vm._s(_vm.successMessage))]
                      ),
                      _vm._v(" "),
                      _c("div", { attrs: { slot: "body" }, slot: "body" }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "col-3 override-padding",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "SendEmailModal",
                {
                  attrs: { isModalVisible: _vm.isModalVisible },
                  on: {
                    close: function($event) {
                      _vm.isModalVisible = false
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "sub-heading",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [_c("h3", [_vm._v("Send Mail")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { slot: "body" }, slot: "body" },
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            show: _vm.dismissCountDown,
                            dismissible: "",
                            variant: "success"
                          },
                          on: {
                            dismissed: function($event) {
                              _vm.dismissCountDown = 0
                            },
                            "dismiss-count-down": _vm.countDownChanged
                          }
                        },
                        [
                          _vm._v(
                            "\n      " + _vm._s(_vm.success_message) + "\n    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { clear: "both" } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.to_email,
                              expression: "to_email"
                            }
                          ],
                          attrs: { type: "hidden" },
                          domProps: { value: _vm.to_email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.to_email = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email_subject,
                              expression: "email_subject"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "col-lg-12 input-height-25 padding-lr-5",
                          attrs: {
                            name: "email_subject",
                            placeholder: "Enter Subject",
                            maxlength: "255"
                          },
                          domProps: { value: _vm.email_subject },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email_subject = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("email_subject", "required")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Subject is required")]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email_message,
                              expression: "email_message"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass:
                            "email-message col-xs-12 col-md-12 col-lg-12 padding-lr-5 input-height-25",
                          attrs: {
                            name: "email_message",
                            placeholder: "Enter Message",
                            maxlength: "500"
                          },
                          domProps: { value: _vm.email_message },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email_message = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("email_message", "required")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Message is required")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-red col-lg-2 col-sm-2 col-3 input-height-25",
                            on: {
                              click: function($event) {
                                return _vm.sendEmailToAdmin()
                              }
                            }
                          },
                          [_c("b", [_vm._v("Send")])]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-3 override-padding",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "d-inline heading" }, [
        _vm._v("Email or Login as Admin")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-274fa10a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-274fa10a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/account_lookup_email_or_login_list.vue
// module id = null
// module chunks = 